import { ClientItemId } from 'owa-client-ids';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import { action } from 'satcheljs';

export const initializeConflictsView = action(
    'ConflictsView_initialize',
    (meetingRequest: MeetingRequestMessageType) => ({
        meetingRequest,
    })
);

export const clickCalendarEvent = action(
    'ConflictsView_clickCalendarEvent',
    (id: ClientItemId) => ({
        id,
    })
);

export const doubleClickCalendarEvent = action(
    'ConflictsView_doubleClickCalendarEvent',
    (id: ClientItemId) => ({
        id,
    })
);
